/* 曹操傳・第 4 章：濮陽火城（興平元年，194）
 * 史實：曹操與呂布爭兗州，攻濮陽。城中大姓田氏詐降、開東門，曹操入城後燒門以示不退，反被呂布所敗；
 *       《武帝紀》：「太祖陳亂，馳突火出，墜馬，燒左手掌。司馬樓異扶太祖上馬，遂引去。」（燒東門、田氏詐降見《獻帝春秋》，裴注）
 * 流程：從東門進城，不久東門起火、關上，火往城裡延燒；呂布的騎兵在巷子裡巡邏，呂布本人也在城中。
 *       西、南、北三座城門只有一座開著，要自己去看；樓異會趕來護著曹操。呂布第一次追上時認不出曹操，被指去追「乘黃馬走者」。逃出城即勝利。 */
// @ts-nocheck
import { SG } from '../../core/sg.ts';
import { setLevel, ally, allyTick, boss, vanish, TROOPS, PEOPLE } from '../kit.ts';
import { CITY, GATES } from '../maps/puyang.ts';

const LV = 7;
const CAV = { spec: TROOPS.dong, name: '呂布騎', hp: 400, maxHp: 400, atk: 22, ms: 250 };
const NAMES = { n: '北門', s: '南門', w: '西門' };

export default {
  id: 'caocao-4', map: 'puyang', hero: 'caocao',
  title: '第 4 章　濮陽火城', year: '興平元年（194）',
  brief: {
    quote: [{ text: '太祖陳亂，馳突火出，墜馬，燒左手掌。', src: '《三國志·魏書·武帝紀》' }],
    text: '曹操與呂布爭奪兗州，進攻濮陽。城中大姓田氏派人來說願為內應，夜裡打開東門。曹操入城後放火燒了東門，表示有進無退。',
    goals: ['進城', '找到開著的城門', '逃出濮陽'],
  },
  words: { ally: '曹軍', foe: '呂布騎' },
  fuel(m, x, y) { return Math.abs(x - CITY.x) < CITY.hw - 40 && Math.abs(y - CITY.y) < CITY.hh - 40 && SG.MAP.walkable(x, y, 0); },
  spreadMul() { return 0.35; },
  stars: [
    { text: '起火後 75 秒內逃出城', ok: (m) => m.vars.outT != null && m.vars.outT < 75 },
    { text: '沒有被火燒到', ok: (m) => !m.vars.burnt },
    { text: '樓異也逃出來了', ok: (m) => m.vars.lou && m.vars.lou.alive },
  ],
  steps: [
    { // 1. 田氏開東門
      enter(m, w) {
        const me = w.player, V = m.vars;
        setLevel(w, me, LV);
        me.x = GATES.e[0] + 600; me.y = GATES.e[1];
        V.men = Array.from({ length: 6 }, (_, i) => { const u = m.recruit(me.x + 80 + (i % 3) * 50, me.y - 60 + Math.floor(i / 3) * 90, '曹軍'); u.spec = TROOPS.wei; m.join(u, me); return u; });
        m.line('曹操', '田氏開了東門！進城！');
        m.mark('in', CITY.x, CITY.y, '濮陽城');
        m.obj('in', '從東門進城');
      },
      tick(m, w) { return w.player.x < GATES.e[0] - 300; },
    },
    { // 2. 東門起火：找出口
      enter(m, w) {
        const me = w.player, V = m.vars;
        m.done('in'); m.unmark('in');
        m.after(3, () => {
          m.big('東門起火了！');
          m.card('燒其東門，示無反意。及戰，軍敗。', '《獻帝春秋》（裴注）');
          m.gate('e', GATES.e[0], GATES.e[1], 190, 'citygate');
          for (const [x, y] of [[GATES.e[0] - 150, GATES.e[1]], [GATES.e[0] - 150, GATES.e[1] - 160], [GATES.e[0] - 150, GATES.e[1] + 160]]) m.fire(x, y, { dps: 60, life: 30 });
          V.fireT = w.t;
          m.wind = [-0.8, 0.1];
          // 只有一座城門開著
          const keys = ['n', 's', 'w'];
          V.open = keys[Math.floor(SG.rand() * 3)];
          for (const k of keys) { if (k !== V.open) m.gate(k, GATES[k][0], GATES[k][1], 190, 'citygate'); m.mark('g' + k, GATES[k][0], GATES[k][1], NAMES[k] + '？', true); }
          // 呂布的騎兵在巷子裡巡邏
          V.cav = [];
          for (const [a, b] of [[[CITY.x - 900, CITY.y - 400], [CITY.x + 400, CITY.y - 400]], [[CITY.x - 900, CITY.y + 400], [CITY.x + 400, CITY.y + 400]], [[CITY.x - 400, CITY.y - 700], [CITY.x - 400, CITY.y + 700]], [[CITY.x, CITY.y - 300], [CITY.x, CITY.y + 300]]]) { const u = m.foe('huangjin', a[0], a[1], CAV); m.patrol(u, [a, b]); V.cav.push(u); }
          V.lb = boss(w, SG.LUBU, GATES.e[0] - 300, GATES.e[1] + 300, { name: '呂布', hp: 9000, atk: 52, armor: 10, ms: 160 }); // 呂布 20 秒後從東門那頭追來（比曹操慢，停下來才會被追上）
          m.line('曹操', '中計了！找別的城門出去！');
          m.obj('out', '找到開著的城門，逃出城');
          m.after(14, () => {
            V.lou = ally(w, PEOPLE.zumao, me.x + 80, me.y + 60, LV); V.lou.name = '樓異';
            m.line('樓異', '主公！樓異來了，快上馬！');
            w.addBuff(me, { id: '上馬', t: 9999, ms: 0.15 });
          });
        });
      },
      tick(m, w) {
        const me = w.player, V = m.vars;
        if (!V.open) return false;
        if (m.burning(me.x, me.y, 60)) V.burnt = true;
        for (const k of ['n', 's', 'w']) if (!V['seen' + k] && m.near(me, GATES[k][0], GATES[k][1], 360)) {
          V['seen' + k] = true; m.unmark('g' + k);
          if (k === V.open) { m.mark('exit', GATES[k][0], GATES[k][1], NAMES[k] + '開著'); m.line('曹操', `${NAMES[k]}開著！走！`); }
          else m.line('曹操', `${NAMES[k]}關著……`);
        }
        const g = GATES[V.open], out = V.open === 'n' ? me.y < g[1] - 200 : V.open === 's' ? me.y > g[1] + 200 : me.x < g[0] - 200;
        if (!out) return false;
        V.outT = w.t - V.fireT;
        return true;
      },
    },
    { // 3. 逃出城
      enter(m, w) {
        m.done('out'); m.unmark('exit');
        m.card('司馬樓異扶太祖上馬，遂引去。', '《武帝紀》');
        m.after(2, () => m.win());
      },
      tick() { return false; },
    },
  ],
  always(m, w) {
    if (!w.player.alive) { m.lose('曹操陷在火城裡'); return; }
    if (m.vars.lou) allyTick(w, m.vars.lou, w.player, 300);
    // 呂布：20 秒後追來；第一次追上時沒認出曹操——「乘黃馬走者是也」，被指去追別人，就此出城
    const lb = m.vars.lb, me = w.player;
    if (lb && lb.alive && !m.vars.fooled) {
      if (w.t - m.vars.fireT > 20) lb.home = [me.x, me.y];
      if (lb.target === me) { lb.target = null; lb.think = 0.5; } // 還沒認出曹操：只追不打
      if (SG.gd(lb.x, lb.y, me.x, me.y) < 150) {
        m.vars.fooled = true;
        m.card('布騎得太祖而不知是，問曰：「曹操何在？」太祖曰：「乘黃馬走者是也。」', '《獻帝春秋》（裴注）');
        lb.untargetable = true; lb.home = [GATES.e[0] - 100, GATES.e[1] - 600]; lb.ms = 260;
        m.after(6, () => vanish(w, lb));
      }
    }
  },
};
